<template>
  <v-dialog v-model="show" persistent fullscreen>
    <v-card>
      <v-card-title>Terms of use</v-card-title>
      <v-divider/>
        <v-card flat>
          <div style="height:calc(100vh - 112px)" class="pa-8 overflow-y" v-html="terms"/>
        </v-card>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show=false;$emit('input',false)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TermsOfUse',
	props: {
    value: {type:Boolean,required:true},
  },
  data() {
    return {
      show: false,
      terms: ''
    }
  },
  watch: {
    value() {
      this.show = this.value;
      if (this.show)
        this.init();
    }
  },
  methods: {
    async init() {
      const body = await axios.get(`/termsofuse.html`);
      this.terms = body.data;
    }
  }
}
</script>
